import { useEffect, useState } from 'react';

const getIsMobile = (mobileWidth: number): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  return window.matchMedia(`(max-width: ${mobileWidth}px)`).matches;
};

export const useMobileDesign = (mobileWidth = 768): boolean => {
  const [isMobile, setIsMobile] = useState(() => getIsMobile(mobileWidth));

  useEffect(() => {
    const mediaQuery = window.matchMedia(`(max-width: ${mobileWidth}px)`);
    const handleChange = (): void => setIsMobile(mediaQuery.matches);

    setIsMobile(mediaQuery.matches);
    mediaQuery.addEventListener('change', handleChange);

    return (): void => mediaQuery.removeEventListener('change', handleChange);
  }, [mobileWidth]);

  return isMobile;
};
